const DATE_OPTIONS = { day: 'numeric', month: 'short', year: 'numeric' };

// Date in the "dd MMM yyyy" form the Musoni API expects (en-GB, e.g. "23 Oct 2026").
export const formatLoanDate = (date = new Date()) => date.toLocaleDateString('en-GB', DATE_OPTIONS);

export const tomorrow = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
};

/**
 * Request body shared by the loan calculation and loan creation calls; the product-driven fields come
 * from the selected product in `userLoanApplicationData`.
 */
export const buildLoanRequestBody = (userLoanApplicationData, { principal, numberOfMonths, loanTermFrequencyType }) => {
    const product = userLoanApplicationData?.selectedProduct;
    return {
        "dateFormat": "dd MMMM yyyy",
        "locale": "en_GB",
        "clientId": userLoanApplicationData?.userData[0]?.entityId,
        "productId": product?.id,
        "principal": principal,
        "loanTermFrequency": numberOfMonths,
        "loanTermFrequencyType": loanTermFrequencyType,
        "loanType": "individual",
        "numberOfRepayments": numberOfMonths,
        "repaymentEvery": 1,
        "repaymentFrequencyType": product?.repaymentFrequencyType?.id,
        "interestRatePerPeriod": product?.interestRatePerPeriod,
        "amortizationType": product?.amortizationType?.id,
        "interestType": product?.interestType?.id,
        "interestCalculationPeriodType": product?.interestCalculationPeriodType?.id,
        "submittedOnDate": formatLoanDate(),
        "expectedDisbursementDate": formatLoanDate(),
        "transactionProcessingStrategyId": product?.transactionProcessingStrategyId,
    };
};
